module.exports = __webpack_public_path__ + "img/Security2.70f5f53.svg";